import React from "react";
import { Field, getIn } from "formik";
import { Col, Container, Row } from "react-bootstrap";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { BeatLoader, MoonLoader } from "react-spinners";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NumericFormat as NumberFormat } from "react-number-format";
import { TIPO_REPUESTO } from "./auth-header";
import productoServiceTs from "../_services/cart/producto.service";

export const ErrorMessage = ({ name }) => (
  <Field name={name}>
    {({ form }) => {
      const error = getIn(form.errors, name);
      const touch = getIn(form.touched, name);
      return touch && error ? (
        <div className="help-block text-danger">
          <i className="fas fa-exclamation-circle"></i>{" "}
          {typeof error === "string" ? error : ""}
        </div>
      ) : null;
    }}
  </Field>
);

export const MyToolTip = ({ texto, id }) => {
  const tooltipId = `helper-${id}`;

  return (
    <>
      &nbsp;&nbsp;
      <span
        className="tooltip__anchor"
        data-tooltip-id={tooltipId}
        data-tooltip-content={texto}
      >
        <FontAwesomeIcon icon="fa-solid fa-circle-info" />
      </span>
      <Tooltip id={tooltipId} place="bottom" className="tooltip__box" />
    </>
  );
};

export const ProductoDP = ({ rowData, editar }) => (
  <Container fluid className="container">
    <Row className="bg-silver p-3 flex-column flex-md-row">
      {rowData.productoBaja != undefined && (
        <Col xs={12} md={12} className="mb-3 mb-md-0 bold text-center">
          <b>
            ID de la Baja
            {" " + rowData.productoBaja.id}
          </b>
          <hr></hr>
        </Col>
      )}

      {!!rowData.descripcion && (
        <Col xs={12} md={12} className="mb-3 mb-md-0 text-center">
          <b>Descripcion publica:</b>
          {rowData.descripcion}
          <hr></hr>
        </Col>
      )}

      {!!rowData.notaInterna && (
        <Col xs={12} md={12} className="mb-3 mb-md-0 text-center">
          <b>Nota Interna: </b>
          {rowData.notaInterna}
          <hr></hr>
        </Col>
      )}

      {rowData.misRepuestosBaja != null &&
        rowData.misRepuestosBaja.length > 0 && (
          <Col xs={12} md={12} sm={12} className="mb-3 w-100">
            <table className="w-100">
              <thead>
                <tr>
                  <td>Tipo Repuesto</td>
                  <td>Estado</td>
                  <td>Precio Unitario</td>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                {rowData.misRepuestosBaja?.map((item, idx) => (
                  <tr>
                    <td className="product_accent--sub">
                      {item.tipoRepuesto?.nombre}
                      {item.tipoRepuesto?.nombre === TIPO_REPUESTO.MOTOR_04 && (
                        <MyToolTip
                          texto={productoServiceTs.crearNombreMotorAsociados(
                            item
                          )}
                          id={item.id.toString()}
                        ></MyToolTip>
                      )}
                    </td>
                    <td className="product_accent--sub">{item.estado}</td>
                    <td className="product_accent--sub">
                      <NumberFormat
                        prefix={"$ "}
                        value={item.precio}
                        displayType={"text"}
                        thousandSeparator="."
                        decimalSeparator=","
                      />
                    </td>
                    <td>
                      <div className="d-iflex text-right">
                        <button
                          className="btns btns-link text-muted mr-0"
                          type="button"
                          title="Editar publicación"
                          aria-label="Editar publicación"
                          onClick={() => editar(item)}
                        >
                          <FontAwesomeIcon icon="fa fa-edit" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Col>
        )}
    </Row>
  </Container>
);

export const UserDP = ({ rowData }) => (
  <Container fluid>
    <Row className="bg-silver p-3">
      <Col xs={2} className="mt-2">
        <h5>
          <span className="badge badge-secondary font-weight-light"></span>
        </h5>
        <p></p>
      </Col>
    </Row>
  </Container>
);

export const prepareDataSearch = (
  query,
  initialOrder,
  initialDireccion,
  searchValues
) => {
  let dataSearch = {
    searchValue: query.search,
    page: query.page,
    pageSize: query.pageSize,
    sortOrders: [
      {
        field: query.orderBy ? query.orderBy.field : initialOrder,
        direction: query.orderDirection
          ? query.orderDirection.toUpperCase()
          : initialDireccion,
      },
    ],
    options: prepareValuesToSearch(searchValues),
  };

  return dataSearch;
};

export const prepareValuesToSearch = (values) => {
  let finalValues = {};

  if (values) {
    Object.keys(values).forEach(function (key) {
      const value = values[key];
      if (!!value) {
        finalValues[key] = value.hasOwnProperty("id") ? value.id : value;
      }
    });
  }

  return finalValues;
};

export const hasValue = (val) => {
  return val !== undefined && val != null && val !== "";
};

export const LoaderGeneral = ({ grabando }) => {
  if (grabando) {
    return (
      <div className="sweet-loading mt-5 mb-5" align="center">
        <MoonLoader size={60} color={"#808080"} loading={grabando} />
      </div>
    );
  }
};

/**
 * Envuelve un campo de contraseña y le apoya el ojo adentro, contra el borde derecho.
 *
 * Estaba resuelto de tres maneras distintas y ninguna dejaba el ojo dentro del campo: en el
 * login el input se encogia al 80% y el ojo quedaba al lado en un cuadradito de fondo blanco
 * fijo (que en modo oscuro ademas era un parche claro); en el registro se posicionaba contra
 * el `.form-group`, que incluye el label, asi que caia sobre el rotulo; y en el cambio de
 * clave el div traia `className` dos veces, asi que JSX se quedaba con el segundo y la clase
 * del ojo se perdia entera.
 *
 * Recibe el input como children para servir igual a un <input> controlado y a un <Field> de
 * Formik, que es lo que usa cada pantalla.
 */
export const CampoPassword = ({ mostrar, onToggle, children }) => (
  <div className="campo-password">
    {children}
    <button
      type="button"
      className="campo-password__ojo"
      onClick={onToggle}
      aria-label={mostrar ? "Ocultar contraseña" : "Mostrar contraseña"}
      aria-pressed={!!mostrar}
      tabIndex={-1}
    >
      <FontAwesomeIcon
        icon={mostrar ? "fa-solid fa-eye-slash" : "fa-solid fa-eye"}
      />
    </button>
  </div>
);

export const LoadingBoton = ({ grabando }) => {
  if (grabando) {
    return (
      <div className="sweet-loading">
        <BeatLoader size={10} color={"#FFFFFF"} loading={grabando} />
      </div>
    );
  } else {
    return <></>;
  }
};

export const exportToCSV = (csvData, fileName) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  const ws = XLSX.utils.json_to_sheet(csvData);
  const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
};

export const exportArrayToCSV = (arrayData, fileName) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";
  const wb = { Sheets: {}, SheetNames: ["data"] };

  arrayData.forEach((element, index) => {
    const ws = XLSX.utils.json_to_sheet(element.data);
    wb.Sheets[element.name] = ws;
    wb.SheetNames[index] = element.name;
  });

  const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
};

export const ExportCSV = ({ csvData, fileName }) => {
  return (
    <button
      className="btns btns-outline-recursos  btn-block"
      onClick={(e) => exportToCSV(csvData, fileName)}
    >
      <i className="fas fa-download"></i> Exportar excel
    </button>
  );
};

/**
 * Etiqueta para mostrar un vendedor. El username es el mail con el que se registro, asi que
 * no sirve como nombre visible: es largo y no dice nada. Preferimos nombre y apellido y, si
 * el vendedor todavia no los cargo, la parte del mail anterior al arroba.
 */
export const nombreVendedor = (vendedor) => {
  if (!vendedor) return "";

  const nombre = `${vendedor.firstName ?? ""} ${vendedor.lastName ?? ""}`.trim();
  if (nombre) return nombre;

  return (vendedor.username ?? "").split("@")[0];
};
